import React from 'react';

import ExternalLink from 'src/presentation/components/pages/shared/ExternalLink';
import { getAdminURL } from 'src/presentation/components/pages/shared/utils/Utils';

const SmsDescription = ({ pageDataAid }): JSX.Element => {
  return <EntryPoints pageDataAid={pageDataAid} />;
};

const EntryPoints = ({ pageDataAid }) => (
  <div data-aid={`${pageDataAid}-description`}>
    Configure and manage your SMS setup.{' '}
    <ExternalLink
      data-aid={`${pageDataAid}-set-up-sms`}
      label="Read Set Up SMS"
      to="https://help.gladly.com/implementation/docs/set-up-sms"
    />{' '}
    to learn more. Looking to manage your Inboxes?{' '}
    <ExternalLink
      data-aid={`${pageDataAid}-goToChannels`}
      label="Go to Entry Points"
      to={getAdminURL('entry-points')}
    />
  </div>
);

export default SmsDescription;
